import pageLoading from './lib/pageLoading.js';
import modalImage from './lib/modalImage.js';
// import { isPage, isMobile } from "./lib/util";
// import scrollEffect from "./lib/scrollEffect.js";
// import observer from "./lib/observer.js";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import topValidation from 'top-validation';
import '@/scss/design.scss';

/**
 * mainimgのラインアニメーション
 */
function initLineAnimations() {
  var triggerSelector = '.js-line-animation-trigger';
  var triggers = document.querySelectorAll(triggerSelector);
  var isMobile = window.matchMedia('(max-width: 768px)').matches;
  var rootMarginValue = isMobile ? '0px 0px -10% 0px' : '-60% 0px -40% 0px';

  if (!triggers.length) {
    return;
  }

  // IntersectionObserver非対応環境では即時適用
  if (!('IntersectionObserver' in window)) {
    triggers.forEach(function(trigger) {
      var targetSelector = trigger.dataset.lineTarget;
      if (!targetSelector) {
        trigger.classList.add('is-active');
        return;
      }
      trigger.querySelectorAll(targetSelector).forEach(function(target) {
        target.classList.add('is-active');
      });
    });
    return;
  }

  var observer = new IntersectionObserver(
    function(entries, obs) {
      entries.forEach(function(entry) {
        if (!entry.isIntersecting) {
          return;
        }

        var trigger = entry.target;
        var targetSelector = trigger.dataset.lineTarget;

        if (!targetSelector) {
          trigger.classList.add('is-active');
        } else {
          trigger.querySelectorAll(targetSelector).forEach(function(target) {
            target.classList.add('is-active');
          });
        }

        // 一度だけ発火
        obs.unobserve(trigger);
      });
    },
    {
      root: null,
      // ビューポート中央付近で発火
      rootMargin: rootMarginValue,
      threshold: 0,
    }
  );

  triggers.forEach(function(trigger) {
    observer.observe(trigger);
  });
}


/**
 * メニューボタン開閉
 */
function initMobileMenu() {
  var menuBtn = document.querySelector('.menu_btn');
  var hdInner = document.querySelector('.hd_inner');
  var mobileMedia = window.matchMedia('(max-width: 1024px)');

  if (!menuBtn || !hdInner) {
    return;
  }

  function closeMenu() {
    menuBtn.classList.remove('is-open');
    hdInner.classList.remove('is-open');
  }

  menuBtn.addEventListener('click', function() {
    if (!mobileMedia.matches) {
      return;
    }

    menuBtn.classList.toggle('is-open');
    hdInner.classList.toggle('is-open');
  });

  hdInner.querySelectorAll('a').forEach(function(link) {
    link.addEventListener('click', function() {
      if (mobileMedia.matches) {
        closeMenu();
      }
    });
  });

  window.addEventListener('resize', function() {
    if (!mobileMedia.matches) {
      closeMenu();
    }
  });
}

/**
 * contactページ　バリデーション
*/
function initContactValidation() {
  if (!document.body.classList.contains('contact')) {
    return;
  }

  topValidation();
}


/**
 * タイトルアニメーション
*/
gsap.registerPlugin(ScrollTrigger);

//テキストを1文字ずつspanタグで囲む関数
function splitTextToSpans(selector) {
  const elements = document.querySelectorAll(selector);
  
  elements.forEach(element => {
    const text = element.textContent;
    element.textContent = "";
    
    const nodes = Array.from(text).map(char => {
      const span = document.createElement("span");
      span.style.display = "inline-block";
      span.textContent = char === " " ? "\u00A0" : char;
      return span;
    });
    
    nodes.forEach(node => element.appendChild(node));
  });
}

// 同じ要素を再分割しないための専用分割関数
function splitMovingTitleToSpans(selector) {
  const elements = document.querySelectorAll(selector);

  elements.forEach(element => {
    if (element.dataset.splitDone === 'true') {
      return;
    }

    const text = element.textContent;
    element.textContent = '';

    Array.from(text).forEach(char => {
      const span = document.createElement('span');
      span.style.display = 'inline-block';
      span.textContent = char === ' ' ? '\u00A0' : char;
      element.appendChild(span);
    });

    element.dataset.splitDone = 'true';
  });
}

function initTitleAnimations() {
  // まとめてテキストを分割
  splitTextToSpans(".main_ttl, .pagettl");
  splitMovingTitleToSpans('.MovingTitle');

  // MVのテキストアニメーション
  gsap.timeline()
    .from(".main_ttl span", {
      opacity: 0,
      y: 30,
      duration: 1.0,
      stagger: 0.05,
      ease: "power2.out",
      delay: 0.2,
    })
    .from(".main_sub_ttl", {
      opacity: 0,
      x: -30,
      duration: 0.8,
      ease: "power2.out",
    })
    .from(".main_img", {
      opacity: 0,
      duration: 0.8,
      ease: "power2.out",
    }, "<");

  // 下層ページのページタイトルアニメーション
  document.querySelectorAll(".pagettl").forEach(title => {
    const chars = title.querySelectorAll("span");

    gsap.from(chars, {
      scrollTrigger: {
        trigger: title,
        start: "top 80%",
        toggleActions: "play none none none"
      },
      opacity: 0,
      y: 20,
      filter: "blur(4px)",
      duration: 0.8,
      stagger: 0.04,
      ease: "power3.out",
    });
  });

  // トップページタイトル: 左から1文字ずつ出現
  document.querySelectorAll('.MovingTitle').forEach(title => {
    const chars = title.querySelectorAll('span');

    gsap.timeline({
      scrollTrigger: {
        trigger: title,
        start: 'top 60%',
        toggleActions: 'play none none none',
      },
    }).from(chars, {
      x: -10,
      opacity: 0,
      duration: 0.5,
      stagger: 0.05,
      ease: 'power2.out',
    });
  });
}//function initTitleAnimations()


document.addEventListener('DOMContentLoaded', () => {
  initLineAnimations();
  initMobileMenu();
  initContactValidation();
  initTitleAnimations();
  modalImage();
  pageLoading();
});

